import React from 'react'

const TrackingLink = ({ trackingLink, tracking }) => {
  return <a href={trackingLink} target="_blank" rel="noopener noreferrer" onClick={(e) => { e.stopPropagation(); }}>{tracking}</a>
}

export default TrackingLink 